export default __webpack_public_path__ + "static/scalac_logo_2160x1080_(1)-673ba31b760c4f420d513e1e0382757e.png";